import 'lazysizes';

// Components
import { cookieBanner } from '../components/cookie-banner'
import { dropdown } from '../components/dropdown'
import { mobileDropdown } from '../components/mobile-dropdown'

// Animations
import { bannerScroll } from '../animation/banner-scroll'
import { fullscreenNav } from '../animation/fullscreen-nav'
import { videoLightboxes } from '../animation/video-lightbox'
import { expandIcons } from '../animation/expand-icons'
import { contractIcons } from '../animation/contract-icons'
import { parallaxFooter } from '../animation/footer'
import { buttonScrollDown } from '../animation/button-scroll-down'

export default {
  init() {
    
    /**************************************************************
    -> Init component-specific functions
    **************************************************************/
    cookieBanner()
    dropdown()
    mobileDropdown()

    /**************************************************************
    -> Init animations
    **************************************************************/
    bannerScroll()
    fullscreenNav()
    videoLightboxes()
    expandIcons()
    contractIcons()
    parallaxFooter()
    buttonScrollDown()

    /**************************************************************
    -> Hide Facet WP loading
    **************************************************************/
    $(function() {
      $(document).on('facetwp-loaded', function() {
        // eslint-disable-next-line no-undef
        FWP.loading_handler = function() { }
      })
    })

    /**************************************************************
    -> Portal elements to top level portal contains
    **************************************************************/
    const elementsToPortal = Array.from(document.querySelectorAll('[data-portal]'))
   
    if (elementsToPortal.length > 0) {
      const portalContainer = document.querySelector('.portal')
      
      elementsToPortal.forEach(lightbox => {
        portalContainer.appendChild(lightbox)
      })
    }

    /**************************************************************
    -> Better calculation of VH units
    **************************************************************/

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    const vh = window.innerHeight * 0.01;

    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // // We listen to the resize event
    window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js